import { inject } from '@angular/core';

import { LiveSectionConfig } from '@frontend/sports/common/client-config-data-access';
import { StylesLazyLoadingService } from '@frontend/sports/deferred/feature/styles-loader';
import { firstValueFrom, tap } from 'rxjs';

import { LiveEventListService, LiveOverviewModel } from './live-event-list.service';

export const liveEsportsResolver = async (): Promise<LiveOverviewModel | undefined> => {
    const liveConfig = inject(LiveSectionConfig);
    const liveEventListService = inject(LiveEventListService);
    const stylesService = inject(StylesLazyLoadingService);

    const eventListService$ = liveEventListService
        .getEsports(liveConfig.maxLiveEventsPerSport)
        .pipe(tap((model) => liveEventListService.notifyParent(model)));

    const [result] = await Promise.all([firstValueFrom(eventListService$, { defaultValue: undefined }), stylesService.lazyLoad('live')]);

    return result;
};

export const liveEsportsPreResolver = () => {
    const liveConfig = inject(LiveSectionConfig);
    const liveEventListService = inject(LiveEventListService);
    const stylesService = inject(StylesLazyLoadingService);

    firstValueFrom(liveEventListService.getEsports(liveConfig.maxLiveEventsPerSport), { defaultValue: undefined });
    stylesService.lazyLoad('live');
};
